import * as React from 'react';

import Icon from '@ant-design/icons/lib/components/Icon';

const IPen = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
            <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 16.2667H12V14.6667H4V16.2667ZM4 12H12V10.4H4V12ZM1.92827 20.2667C1.38942 20.2667 0.933333 20.08 0.56 19.7067C0.186667 19.3333 0 18.8772 0 18.3384V1.92827C0 1.38942 0.186667 0.933333 0.56 0.56C0.933333 0.186667 1.38942 0 1.92827 0H10.4L16 5.6V18.3384C16 18.8772 15.8133 19.3333 15.44 19.7067C15.0667 20.08 14.6106 20.2667 14.0717 20.2667H1.92827ZM9.6 6.4V1.6H1.92827C1.84613 1.6 1.77093 1.63422 1.70267 1.70267C1.63422 1.77093 1.6 1.84613 1.6 1.92827V18.3384C1.6 18.4205 1.63422 18.4957 1.70267 18.564C1.77093 18.6324 1.84613 18.6667 1.92827 18.6667H14.0717C14.1539 18.6667 14.2291 18.6324 14.2973 18.564C14.3658 18.4957 14.4 18.4205 14.4 18.3384V6.4H9.6Z" fill="#AEA9B1"/>
</svg>


        );
      }}
      {...props}
    />
  );
};

export default IPen;
